import { CheckoutAbTestMetricToOptimize } from "@redotech/redo-conversion-core-common/checkouts/checkout-ab-test-builder";
import { checkoutAnalyticsVersionEnum } from "@redotech/redo-conversion-core-common/conversion/checkout-conversion-metrics/analytics";
import { CheckoutExperienceZodArraySchema } from "@redotech/redo-conversion-core-common/redo-in-shipping/ris";
import { checkoutOptimizationTreatmentStorefrontFeaturesSchema } from "@redotech/redo-conversion-core-common/split-slices";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const treatmentSchema = z.object({
  id: zExt.objectId(),
  name: z.string(),
  isSpecialExistingExperienceTreatment: z.boolean(),
  allCheckoutExperiences: CheckoutExperienceZodArraySchema,
  storefrontFeatures:
    checkoutOptimizationTreatmentStorefrontFeaturesSchema.optional(),
});
export type GetCheckoutSplitDetailsTreatment = z.infer<typeof treatmentSchema>;

const splitDetailSchema_ = z.object({
  _id: zExt.objectId(),
  name: z.string(),
  description: z.string(),
  metricToOptimize: createEnum(CheckoutAbTestMetricToOptimize),
  status: createEnum(["in_progress", "concluded", "scheduled"]),
  controlTreatment: treatmentSchema,
  variantTreatments: z.array(treatmentSchema),
  startDate: z.date().optional(),
  endDate: z.date().optional(),
  analyticsVersionOverride: createEnum(checkoutAnalyticsVersionEnum).optional(),
  rootSplitId: zExt.objectId().optional(),
  generation: z.number().optional(),
});
export const splitDetailSchema: z.ZodType<SplitDetail> = splitDetailSchema_;
export interface SplitDetail extends z.infer<typeof splitDetailSchema_> {}

export const getCheckoutSplitDetails = {
  name: "getCheckoutSplitDetails" as const,
  input: z.object({ splitId: zExt.objectId() }),
  output: splitDetailSchema_.extend({
    lineageSplits: z.array(splitDetailSchema).optional(),
  }),
};
export type GetCheckoutSplitDetailsOutput = z.infer<
  typeof getCheckoutSplitDetails.output
>;
